import { Switch } from 'antd'
import React from 'react'
import './SwitchInput.scss'


export default function SwitchInput({ checked, onChange, disabled = false }) {
    return <Switch checked={checked} onChange={onChange} disabled={disabled} />;
}
